import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home.js";
import SignIn from "./SignIn.js";
import SignUp from "./SignUp.js";
import Subscription from "./Subscription.js";
import HelpSupport from "./HelpSupport.js";
import RequireAuth from "./components/RequireAuth.js";




function App() {
  return (
    <Router>

      <Routes>
        {/* Open: the two ways to obtain a session. */}
        <Route path="/" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />

        {/* Everything else needs one. */}
        <Route path="/home" element={<RequireAuth><Home /></RequireAuth>} />
        <Route path="/subscription" element={<RequireAuth><Subscription /></RequireAuth>} />
        <Route path="/help-support" element={<RequireAuth><HelpSupport /></RequireAuth>} />

      </Routes>
    </Router>
  );
}

export default App;
